<script setup lang="ts">
defineProps({
  id: {
    required: false,
    type: String,
    default: '',
  },
  firstName: {
    required: true,
    type: String,
  },
  lastName: {
    required: true,
    type: String,
  },
  email: {
    required: true,
    type: String,
  },
  username: {
    required: false,
    type: String,
    default: '',
  },
});
</script>

<template>
  <!-- Used in User Dropdowns, like Add Member, Template Editor Form & Project Data Fomr -->
  <div class="user-tile">
    <span class="name">
      {{ firstName ? firstName + ' ' : '' }} {{ lastName || '' }}
    </span>
    <span class="email">{{ email }}</span>
  </div>
</template>

<style scoped lang="scss">
.user-tile {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: px(380);

  .name {
    font-weight: var(--font-weight-bold);
    margin-right: var(--space-8);
    color: var(--color-gray-700);
  }
  .email {
    color: var(--color-gray-500);
  }
}
</style>
